import React, { useState } from 'react';
import { soundManager } from '../../utils/soundManager';
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    soundManager.play('ui-click', 0.4);

    if (email && email.includes('@')) {
      setSubscribed(true);
      console.log('Newsletter subscription:', email);
      
      setTimeout(() => {
        setEmail('');
        setSubscribed(false);
      }, 3000);
    }
  };

  const scrollToSection = (sectionId) => {
    soundManager.play('ui-click', 0.3);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    soundManager.play('ui-click', 0.3);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer id="contact" className="footer">
      <div className="footer-container">
        {/* Top Section */}
        <div className="footer-top">
          {/* Brand Column */}
          <div className="footer-column brand-column">
            <div className="footer-logo" onClick={scrollToTop}>
              <span className="logo-diamond">◆</span>
              <span className="logo-text">CHRONOS</span>
            </div>
            <p className="footer-tagline">Time Perfected</p>
            <p className="footer-description">
              Swiss luxury timepieces crafted with uncompromising precision 
              and artistry since 1873. Each watch is a testament to our 
              heritage of horological excellence.
            </p>
            
            {/* Social Links */}
            <div className="social-links">
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" fill="none">
                  <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/>
                  <circle cx="18" cy="6" r="1" fill="currentColor"/>
                </svg>
              </a>
              
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Facebook"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
              </a>
              
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Twitter"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/>
                </svg>
              </a>
              
              <a 
                href="https://youtube.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="YouTube"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.54 6.42a2.78 2.78 0 00-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 00-1.94 2A29 29 0 001 11.75a29 29 0 00.46 5.33A2.78 2.78 0 003.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 001.94-2 29 29 0 00.46-5.25 29 29 0 00-.46-5.33z"/>
                  <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" fill="#0A0A0A"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Collections Column */}
          <div className="footer-column">
            <h4 className="footer-heading">Collections</h4>
            <ul className="footer-links">
              <li>
                <button onClick={() => scrollToSection('collections')} className="footer-link">
                  Royal Series
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('collections')} className="footer-link">
                  Sport Series
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('collections')} className="footer-link">
                  Classic Series
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('configurator')} className="footer-link">
                  Bespoke Creation
                </button>
              </li>
            </ul>
          </div>

          {/* About Column */}
          <div className="footer-column">
            <h4 className="footer-heading">About</h4>
            <ul className="footer-links">
              <li>
                <button onClick={() => scrollToSection('heritage')} className="footer-link">
                  Our Heritage
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('craftsmanship')} className="footer-link">
                  Craftsmanship
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('video-showcase')} className="footer-link">
                  The Making Of
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="footer-link">
                  Client Stories
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
<div className="footer-column">
  <h4 className="footer-heading">Contact</h4>
  <ul className="footer-contact">
    <li className="contact-item">
      <span className="contact-icon">
        <svg viewBox="0 0 24 24" fill="none">
          <path 
            d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <circle 
            cx="12" 
            cy="10" 
            r="3" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span className="contact-text">
        Rue du Rhône 45<br />
        1204 Geneva, Switzerland
      </span>
    </li>
    <li className="contact-item">
      <span className="contact-icon">
        <svg viewBox="0 0 24 24" fill="none">
          <path 
            d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span className="contact-text">+41 22 XXX XXXX</span>
    </li>
    <li className="contact-item">
      <span className="contact-icon">
        <svg viewBox="0 0 24 24" fill="none">
          <path 
            d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <polyline 
            points="22,6 12,13 2,6" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span className="contact-text">boutique@chronos.ch</span>
    </li>
  </ul>
</div>

          {/* Newsletter Column */}
          <div className="footer-column newsletter-column">
            <h4 className="footer-heading">Stay Updated</h4>
            <p className="newsletter-description">
              Subscribe to receive exclusive updates on new collections 
              and private events.
            </p>
            
            {!subscribed ? (
              <form className="newsletter-form" onSubmit={handleSubscribe}>
                <input
                  type="email"
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="newsletter-input"
                  required
                />
                <button type="submit" className="newsletter-button">
                  Subscribe
                </button>
              </form>
            ) : (
              <div className="newsletter-success">
                <span className="success-checkmark">✓</span>
                <span className="success-text">Subscribed successfully!</span>
              </div>
            )}
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider"></div>

        {/* Bottom Section */}
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <p className="copyright">
              © {new Date().getFullYear()} CHRONOS. All rights reserved.
            </p>
            <span className="footer-separator">|</span>
            <p className="swiss-made">Swiss Made Excellence Since 1873</p>
          </div>

          <div className="footer-bottom-right">
            <button className="footer-legal-link">Privacy Policy</button>
            <span className="footer-separator">•</span>
            <button className="footer-legal-link">Terms of Service</button>
            <span className="footer-separator">•</span>
            <button className="footer-legal-link">Cookie Settings</button>
          </div>
        </div>

        {/* Scroll to Top Button */}
        <button 
          className="scroll-to-top"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <svg viewBox="0 0 24 24" fill="none">
            <path 
              d="M12 19V5M5 12l7-7 7 7" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </footer>
  );
};

export default Footer;